import { asList, getBody, server } from '@lib/api/http';
import { queryKeys } from '@lib/api/queryKeys';
import { useSession } from '@lib/auth/session';
import { useQuery } from '@tanstack/react-query';

export const useCategoriesQuery = () => {
  const loggedIn = useSession();
  return useQuery({
    queryKey: queryKeys.categories,
    queryFn: async () =>
      asList(
        await getBody<{ data?: unknown[] }>(
          `${server}v1/sub-categories/categories-and-sub-categories`
        )
      ),
    enabled: loggedIn,
  });
};
